import React from 'react';

import { Text } from '@simplybusiness/mobius-core';

const Header = ({ policyNumber }) => (
  <Text
    component="h1"
    marginTop={0}
    marginBottom="size-40"
    color="#262626"
    fontSize={31}
  >
    Please answer the following question for policy:
    {' '}
    {policyNumber}
  </Text>
);

export default Header;
